module.exports = __webpack_public_path__ + "static/media/temperature-solution.47d76ed7.svg";